import React from "react";

import { StyledSVG } from "../StyledIcon";

export const BigStarIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 60 60"
      fill="none"
      {...props}
    >
      <path
        d="M29.0489 4.92705C29.3483 4.00574 30.6517 4.00574 30.9511 4.92705L36.0619 20.6565C36.1958 21.0686 36.5797 21.3475 37.0129 21.3475H53.5519C54.5206 21.3475 54.9234 22.5871 54.1397 23.1565L40.7594 32.8779C40.4089 33.1325 40.2622 33.5839 40.3961 33.9959L45.5069 49.7254C45.8063 50.6467 44.7518 51.4129 43.9681 50.8435L30.5878 41.1221C30.2373 40.8675 29.7627 40.8675 29.4122 41.1221L16.0319 50.8435C15.2482 51.4129 14.1937 50.6467 14.4931 49.7254L19.6039 33.9959C19.7378 33.5839 19.5911 33.1325 19.2406 32.8779L5.86031 23.1565C5.0766 22.5871 5.47938 21.3475 6.4481 21.3475H22.9871C23.4203 21.3475 23.8042 21.0686 23.9381 20.6565L29.0489 4.92705Z"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
